var _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _path7, _ellipse2, _ellipse3, _linearGradient, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMegaphoneSvgrepoCom = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.82 111.42l-13.38.54c-4.53-.1-6.01-1.45-7.62-5.53l-3.41-8.6l6.28-1.31l2.95 7.45a1.99 1.99 0 0 0 1.99 1.26l10.5-.76c2.93-.31 3.41-2 2.78-3.59l-3.16-7.97l7.98-2.78l3.47 8.77c1.09 2.76 1.83 5.82.57 8.31c-1.45 2.87-3.77 3.99-8.95 4.21z",
    fill: "#82aec0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.63 98.38l1.82 4.59s.71-1.06 3.02-1.26c2.63-.23 3.66.96 3.66.96l-1.87-4.72l-6.63.43z",
    fill: "#2f7889"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.35 96.92l8.85-.59c1.2 2.59 1.73 4.63 1.73 4.63s-1.85-1.55-5.29-1.32c-2.46.16-3.49 1.87-3.49 1.87l-1.8-4.59z",
    fill: "#2f7889"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-21.604 15.324 86.192)",
    cx: 15.33,
    cy: 86.2,
    rx: 9.89,
    ry: 17.95,
    fill: "#b8dade"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.58 94.5c-1.96-1.48-7.27 2.58-7.27 2.58c-.68 4.75-5.93 3.38-5.93 3.38c2.89 2.44 5.98 3.44 8.56 2.42c2.74-1.08 4.33-4.25 4.64-8.38z",
    fill: "#82aec0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.96 14.59L13.37 69.62c-2.68 1.84-3.95 9.22-.63 17.6s9.4 13.24 12.58 12.18l86.86-5.94c9.43-3.73 10.08-24.42 1.46-46.2s-23.25-36.4-32.68-32.67z",
    fill: "#f44336"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.17 80.52c3.19 4.71-1.91 4.92-22.42 8.34c-5.61.94-53.44 8.23-53.44 8.23c1.29 1.19 3.87 3.04 6.07 2.33c0 0 85.21-5.32 86.81-5.95L95.17 80.52z",
    fill: "#c62828"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.39 27.74c1.4-1.01 3.41-2.57 3.89-5.27c.25-1.41.43-3.02.76-3.71c.65-1.37 3.14-4.51 3.14-4.51l-67.8 55.37c-1.83 1.25-2.09 3.34-2.09 3.34c10.38-7.78 51.78-37.75 62.1-45.22z",
    fill: "#c62828"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-21.604 100.448 52.485)",
    cx: 100.46,
    cy: 52.49,
    rx: 18.08,
    ry: 44.77,
    fill: "#b8dade"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-21.604 102.614 51.627)",
    cx: 102.62,
    cy: 51.63,
    rx: 11.86,
    ry: 37.15,
    fill: "#2f7889"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab13617",
    gradientUnits: "userSpaceOnUse",
    x1: 115.708,
    y1: 83.059,
    x2: 103.15,
    y2: 52.92
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#353738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738",
    stopOpacity: 0
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.3 86.17c6.09-2.41 4.9-19.83-2.65-38.91L91.6 56c7.55 19.07 18.61 32.58 24.7 30.17z",
    fill: "url(#IconifyId17ecdb2904d178eab13617)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.71 37.64c-1.29-5.68-1.18-10.86-.36-14.91c.23-1.1.99-2.42 2.12-2.29c1.12.13 1.45 1.19 1.32 2.31c-.44 3.82-.1 9.08.92 14.07c.23 1.11.21 2.56-1.36 3.12c-1.36.5-2.41-1.3-2.64-2.3z",
    fill: "#ffffff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15 75.47l55.73-37.52c1.7-1.13 3.81-3 4.23.76c.26 2.34.56 4.36.35 7.4c-.13 1.89-3.84 3.35-5 3.94L14.93 78.84c-.84.42-2.4.81-2.14-.7c.29-1.63 1.76-2.37 2.21-2.67z",
    opacity: 0.45,
    fill: "#ffca28"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMegaphoneSvgrepoCom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/megaphone-svgrepo-com.5552938d27a7e62a1d8f74275975d673.svg";